// @flow
import { createReducer } from 'redux-act';

import type { BundleType } from '@gandi/cart';

import type {
  BundleState as State,
  BundlePricingApi,
  AvailableBundleApi,
} from '../../types/index';
import { set, setPricing, reset } from '../actions/bundle';
import { reset as resetResults } from '../actions/results';

const initialState: State = null;

export const setHandler = (
  state: State,
  bundle: AvailableBundleApi,
): State => ({
  ...state,
  [bundle.type]: {
    // event: bundle_available
    // {
    //   "type": "popularity",
    //   "content": ["parisweb.tools", "parisweb.app", "parisweb.design"],
    //   "grids": ["A", "B", "C"]
    // }
    ...bundle,
    items: undefined,
    total: undefined,
  },
});

export const setPricingHandler = (
  state: State,
  pricing: BundlePricingApi,
  // $FlowFixMe[incompatible-return] TODO: fix type
  // $FlowFixMe[prop-missing] TODO fix type
): State => ({
  ...state,
  // $FlowFixMe[incompatible-type] TODO: fix type
  // $FlowFixMe[prop-missing] TODO: fix type
  [pricing.type]: {
    ...state?.[pricing.type],
    ...pricing,
  },
});

export const resetHandler = (state: State, type: BundleType): State => {
  if (state !== null) {
    const { [type]: _, ...newState } = state;
    return newState;
  }

  return state;
};

export const resetResultsHandler = (): State => initialState;

export default (createReducer(
  {
    [set.toString()]: setHandler,
    // $FlowFixMe[prop-missing] TODO: fix type
    [setPricing.toString()]: setPricingHandler,
    // $FlowFixMe[incompatible-type] TODO: fix type
    [reset.toString()]: resetHandler,
    [resetResults.toString()]: resetResultsHandler,
  },
  initialState,
): {
  (): (state: State) => State,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<State>,
  options: () => mixed,
  ...
});
